module.exports = __webpack_public_path__ + "static/media/image5.b3f16c9b.jpg";